// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"q9-z"};